<template class="sticky-header">
  <section id="sp-submitastory">
    <div class="row">
      <div id="sp-position-0" class="col-lg-12">
        <div class="sp-column">
          <div class="sp-module">
            <div class="sp-module-content">
              <div class="custom">
                <p style="font-weight: bold; font-size: 17px">
                  <img
                    style="float: left; padding-right: 5px; padding-top: 5px"
                    src="/static/img/icons/submit_story.png"
                    alt
                  />
                  <router-link to="/submit">Submit an entry</router-link>
                </p>
              </div>
            </div>
          </div>
          <div class="sp-module" v-if="!isLoggedIn">
            <div class="sp-module-content">
              <div class="custom">
                <p style="font-weight: bold; font-size: 17px">
                  <img
                    style="float: left; padding-right: 5px; padding-top: 5px"
                    src="/static/img/icons/submit_story.png"
                    alt
                  />
                  <router-link to="/login?redirect=%2Fsubmissions"
                    >Sign in to Glossary</router-link
                  >
                </p>
              </div>
            </div>
          </div>
          <div class="sp-module" v-if="isLoggedIn">
            <div class="sp-module-content">
              <div class="custom">
                <p style="font-weight: bold; font-size: 17px">
                  <img
                    style="float: left; padding-right: 5px; padding-top: 5px"
                    src="/static/img/icons/submit_story.png"
                    alt
                  />
                  <router-link to="/submissions">Submissions</router-link>
                </p>
              </div>
            </div>
          </div>
          <div class="sp-module" v-if="isLoggedIn">
            <div class="sp-module-content">
              <div class="custom">
                <p style="font-weight: bold; font-size: 17px">
                  <img
                    style="float: left; padding-right: 5px; padding-top: 5px"
                    src="/static/img/icons/submit_story.png"
                    alt
                  />
                  <a href="#" @click="logout()">Logout</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "LinkBlock",
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    role() {
      return this.$store.getters.role;
    },
  },
  methods: {
    logout: function () {
      this.$router.push("/");
      this.$store.dispatch("logout");
    },
  },
};
</script>

<style lang="scss">
#sp-submitastory {
  z-index: 9999;
  top: 10px;
  #sp-position-0 .sp-column {
    padding: 14px 20px 1px 20px;
    background: #fdee21;
  }
  p {
    margin: 0 0 20px;
  }
}
</style>



// WEBPACK FOOTER //
// LinkBlock.vue?17091de8